export default "__VITE_ASSET__ec715477__"